
export const showTabs = (permissions, type) => {
    const { admin, freeUser, eduUser, earningsUser, coachingUser, portfolioTools } = permissions

    const state = {
        isDashboard: freeUser || eduUser,
        isEarnings: earningsUser,
        isTrades: eduUser || portfolioTools,
        isCalculators: admin || freeUser || eduUser || portfolioTools,
        isCoaching: coachingUser,
        isQuotes: eduUser || portfolioTools,
        isTradeMatrix: eduUser,
        isAdmin: admin,
    }

    return state[type]
}

export const showDashboardItems = (permissions, type) => {
    const { eduUser, earningsUser } = permissions

    const state = {
        isMarkets: eduUser || earningsUser === false,
        isCalender: eduUser,
        isEarnings: eduUser || earningsUser,
        isPositions: eduUser,
    }

    return state[type]
}


// WEBPACK FOOTER //
// ./src/components/sidebar-permisson/index.js